import React, {useEffect, useState} from "react";
import {withAuth} from "../../hoc/Auth";
import Api from "../../Api";
import {Wrapper, Container, Column} from "../../hoc/Layout";
import {MultipleSelect} from "../../Components/Utils/FieldsHelper";
import PayoutsFilters from "../../Components/PayoutsFilters";
import DateRange from "../../Components/Utils/DateRange";
import RegistryList from "../../Components/RegistryList";
import ReportWidget from "../../Components/Utils/ReportWidget";
import ResponsiveSidebarFilters from "../../Components/Utils/ResponsiveSidebarFilters";

import EmptyCard from "../../hoc/EmptyCard";

import Pagination from "react-js-pagination";

import classes from "./styles.module.css";

const PAYOUT_REGISTRIES_LIST = 128;

function checkAccess(accountAccessSettings, globalPrivileges, bitMask) {
    if (globalPrivileges !== null && globalPrivileges !== undefined) {
        return (globalPrivileges & bitMask) > 0;
    }
    if (Array.isArray(accountAccessSettings)) {
        return accountAccessSettings.some(el => (el.privileges & bitMask) > 0);
    }
    return false;
}

export default withAuth(({token, accountAccessSettings, globalPrivileges}) => {

        const [projects, setProjects] = useState(null);
        const [terminals, setTerminals] = useState(null);

        const [currentRegistryPage, setCurrentRegistryPage] = useState(1);
        const [postsPerRegistryPage, setPostsPerRegistryPage] = useState(15);

        const [registryList, setRegistryList] = useState([]);

        const [tagsList, setTagsList] = useState([]);

        const [registryListCount, setRegistryListCount] = useState(0);

        const [filterProjects, setFilterProjects] = useState([]);
        const [filterTerminals, setFilterTerminals] = useState([]);
        const [filterDate, setFilterDate] = useState({});
        const [filterTagsList, setFilterTagsList] = useState([]);
        const [filters, setFilters] = useState([]);

        const [isLoadingProjects, setIsLoadingProjects] = useState(true);
        const [loadingRegistryList, setLoadingRegistryList] = useState(false);
        const [loadingTagsList, setLoadingTagsList] = useState(false);
        const [isOpenModal, setIsOpenModal] = useState(false);

        useEffect(() => {

            new Api({token}).getProjects().then(
                (response) => {
                    setProjects(response);
                    setIsLoadingProjects(false)
                }
            );

            new Api({token}).setRegistryList({itemsPerPage: postsPerRegistryPage, page: currentRegistryPage}).then(
                (r) => {
                    setRegistryList(r.data);
                    setRegistryListCount(r.count);
                    setLoadingRegistryList(true);
                }
            );

            new Api({token}).getAllTags().then(
                (response) => {
                    setTagsList(response);
                    setLoadingTagsList(true);
                }
            )

        }, [])

        useEffect(() => {

            let terminals = [];
            let cleanFilterTerminals = [];

            filterProjects.map(projectUUID => {
                const result = projects.find(el => el.uuid === projectUUID);

                result.providers.map(el => {
                    return terminals.push(el);
                })

                return true;
            });

            filterTerminals.map(uuid => {
                const result = terminals.find(el => el.uuid !== uuid);

                if (result !== undefined)
                    cleanFilterTerminals.push(result.uuid);

                return true;
            })

            setFilterTerminals(cleanFilterTerminals);
            setTerminals(terminals);

        }, [filterProjects])

        function onSelectProjects(data) {
            setFilterProjects(data);
        }

        function selectFilter(filter) {

            const key = Object.keys(filter)[0];
            const value = Object.values(filter)[0];

            if (value) {
                setFilters([...filters, filter]);
            } else {

                filters.map((el, index) => {

                    if (Object.keys(el)[0] === key) {
                        filters.splice(index, 1);
                        setFilters(filters);
                    }

                    return true;

                })
            }
        }

        function applyFilters(registryPage) {

            if (registryPage)
                setCurrentRegistryPage(registryPage);
            else
                setCurrentRegistryPage(1);

            if (postsPerRegistryPage)
                setPostsPerRegistryPage(postsPerRegistryPage)

            const registryFilters = {
                projects: filterProjects,
                providers: filterTerminals,
                tags: filterTagsList,
                filters: filters,
                dateRange: filterDate,
                page: registryPage,
                itemsPerPage: postsPerRegistryPage
            }

            setLoadingRegistryList(false);

            new Api({token}).setRegistryList(registryFilters).then(
                (r) => {
                    setRegistryList(r.data);
                    setRegistryListCount(r.count);
                    setLoadingRegistryList(true);
                }
            );
        }

        function setRegistryPage(page, itemsPerPage) {

            if (page)
                setCurrentRegistryPage(page);
            else
                setCurrentRegistryPage(1);

            if (itemsPerPage)
                setPostsPerRegistryPage(itemsPerPage)

            const registryFilters = {
                projects: filterProjects,
                providers: filterTerminals,
                filters: filters,
                dateRange: filterDate,
                page: page,
                itemsPerPage: itemsPerPage
            }

            new Api({token}).setRegistryListFilters(registryFilters).then((response) => {
                setRegistryList(response.data);
            });
        }

        function onSelectedTag(tags) {

            let filterTags = [];

            tags.map(tag => {
                if (!filterTags.includes(tag.id))
                    return filterTags.push(tag.id);
                else
                    return false;
            })

            setFilterTagsList(filterTags);
        }

        function onSelectTerminals(data) {
            setFilterTerminals(data);
        }

        if (!checkAccess(accountAccessSettings, globalPrivileges, PAYOUT_REGISTRIES_LIST)) {
            return (
                <Wrapper>
                    <Container style={{justifyContent: "center"}}>
                        <Column width={1180}>
                            <div className="d-flex justify-content-center align-items-center" style={{minHeight: '60vh'}}>
                                <div className="text-center">
                                    <h4>Нет доступа</h4>
                                    <p className="text-muted">У вас нет прав для просмотра этого раздела</p>
                                </div>
                            </div>
                        </Column>
                    </Container>
                </Wrapper>
            );
        }

        return (
            <Wrapper>
                <Container>
                    <Column width="780" className={classes.MainColumn}>
                        <button type="button" className={classes.FiltersToggle} onClick={() => setIsOpenModal(true)}>
                            Фильтры
                        </button>

                        <div className={classes.Card}>
                            <RegistryList token={token} data={registryList} isLoading={loadingRegistryList}/>

                            {postsPerRegistryPage < registryListCount &&
                                <div className={classes.PaginationWrap}>
                                    <Pagination
                                        firstPageText="⇤"
                                        prevPageText="⇠"
                                        lastPageText="⇥"
                                        nextPageText="⇢"
                                        activeLinkClass={classes.ActiveLink}
                                        activePage={currentRegistryPage}
                                        itemsCountPerPage={postsPerRegistryPage}
                                        totalItemsCount={registryListCount}
                                        pageRangeDisplayed={5}
                                        onChange={(page) => setRegistryPage(page, postsPerRegistryPage)}
                                    />
                                </div>
                            }
                        </div>
                    </Column>

                    <Column width="350" className={classes.SidebarColumn}>
                        <ResponsiveSidebarFilters title="Фильтры" isOpen={isOpenModal} onClose={() => setIsOpenModal(false)}>
                            <EmptyCard>
                                <MultipleSelect
                                    label={"FieldsHelper.label.project"}
                                    placeholder={"FieldsHelper.label.selectProject"}
                                    values={projects}
                                    selectedValues={filterProjects}
                                    isLoading={isLoadingProjects}
                                    onChange={onSelectProjects}
                                    excludeSearchColumn={[]}
                                />
                                <MultipleSelect
                                    label={"FieldsHelper.label.terminal"}
                                    placeholder={"FieldsHelper.label.selectTerminal"}
                                    values={terminals}
                                    selectedValues={filterTerminals}
                                    isLoading={isLoadingProjects}
                                    onChange={onSelectTerminals}
                                    excludeSearchColumn={[]}
                                />
                            </EmptyCard>

                            <EmptyCard>
                                <DateRange onSelectDate={(range) => setFilterDate(range)} defaultPeriod={'halfYear'}/>
                            </EmptyCard>

                            <PayoutsFilters loadingTagsList={loadingTagsList}
                                            tagsList={tagsList}
                                            onSelectFilter={selectFilter}
                                            filterProjects={filterProjects}
                                            onApplyFilters={applyFilters}
                                            onSelectedTag={onSelectedTag}
                                            isLoading={loadingRegistryList}
                            />

                            <ReportWidget access={true} token={token} type='payout' filter={{
                                projects: filterProjects,
                                tags: filterTagsList,
                                filters: filters,
                                dateRange: filterDate
                            }} count={registryListCount} countLabel={"Реестров"} date={filterDate} name={"payout_report"}/>
                            <ReportWidget access={["STATISTICS_REPORT_1C_VIEW"]} token={token} type='payout1C' filter={{
                                projects: filterProjects,
                                tags: filterTagsList,
                                filters: filters,
                                dateRange: filterDate
                            }} count={registryListCount} countLabel={"Реестров"} date={filterDate} name={"payout_report"}/>
                        </ResponsiveSidebarFilters>
                    </Column>
                </Container>
            </Wrapper>
        )

    }
)



// WEBPACK FOOTER //
// ./src/PagesOfUser/Payouts/index.js